import { useForm } from 'react-hook-form';

import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import { Typography, Box } from '@mui/material';
import MuiDialog from 'components/MuiDialog';

import { SurveyDialogProps, TAdmAndDischargeDefaultValues } from '../../type';
import { updateAdmAndDischarge } from 'apis/survey';

import CommonPatientInfo from '../../components/CommonPatientInfo';
import GuardianInfo from './GuardianInfo';
import Signature from './Signature';

const AdmissionAndDischarge = (
  props: SurveyDialogProps<TAdmAndDischargeDefaultValues>
) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { handleSubmit, watch, getValues, setValue, register } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TAdmAndDischargeDefaultValues) => {
    const {
      date,
      patient_name,
      patient_sig,

      guardian_name,
      guardian_sig,
      guardian_birth,
      guardian_phone,
    } = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      adm_discharge: {
        date,
        patient_name,
        patient_sig,

        guardian_name,
        guardian_sig,
        guardian_birth,
        guardian_phone,
      },
    };

    updateAdmAndDischarge(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => {
        onFail('저장에 실패하였습니다', e);
      });
  };

  const formProps = {
    disabled,
    watch,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    register,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Typography
        sx={{
          margin: '40px auto 40px auto',
          fontWeight: '700',
          fontSize: '16px',
          textAlign: 'center',
        }}
      >
        입·퇴원 동의서
      </Typography>
      <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
      <Box sx={{ marginTop: '48px' }}>
        <GuardianInfo {...formProps} />
        <Signature {...formProps} />
      </Box>
    </MuiDialog.SurveyForm>
  );
};

export default AdmissionAndDischarge;
